import { isPresent } from '@ember/utils'
import Component from '@glimmer/component'
import { TeacherToolkitCategoryHeader } from 'teacher-ui-client/components/teacher-toolkit/category-header'
import { TeacherToolkitCategoryTiles } from 'teacher-ui-client/components/teacher-toolkit/category-tiles'
import { TeacherToolkitResourcesList } from 'teacher-ui-client/components/teacher-toolkit/resources-list'
import type { TeacherResourceCategoryEntry } from 'teacher-ui-client/contentful-client/entry-types'

interface Args {
  category: TeacherResourceCategoryEntry
}

function hasImage(maybeHasImage?: TeacherResourceCategoryEntry): maybeHasImage is TeacherResourceCategoryEntry {
  return maybeHasImage?.fields.image !== undefined
}

export class TeacherToolkitCategoryBlock extends Component<Args> {
  get subCategoriesWithImage() {
    const subCategories = this.args.category.fields?.categories ?? []
    return subCategories.filter(hasImage)
  }

  get categoryResources() {
    return this.args.category.fields.resources?.filter(isPresent) ?? []
  }

  <template>
    {{! Header will link deeper if subcategories exist }}
    <TeacherToolkitCategoryHeader class="py-3" @category={{@category}} />
    {{! Image tiles for all sub categories }}
    {{! Only care about sub categories with images, since the header above will link deeper to see the other sub cats }}
    {{#if this.subCategoriesWithImage}}
      <TeacherToolkitCategoryTiles class="my-4" @categories={{this.subCategoriesWithImage}} />
    {{/if}}
    {{#if this.categoryResources}}
      <TeacherToolkitResourcesList class="mt-2 mb-8" @resources={{this.categoryResources}} />
    {{/if}}
  </template>
}
